import { render, staticRenderFns } from "./remetente.vue?vue&type=template&id=12352c46&scoped=true&"
import script from "./remetente.vue?vue&type=script&lang=js&"
export * from "./remetente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12352c46",
  null
  
)

export default component.exports